import { useMutation } from '@tanstack/react-query';

import { ADMIN_SELECTED_USER_ID_KEY } from '#constants/localstorage-keys.ts';

import { tanstackQueryClient } from '../../services/tanstackQueryClient.ts';

export const useSelectUserMutation = () => {
  return useMutation({
    mutationFn: (updateData: string) => {
      localStorage.setItem(ADMIN_SELECTED_USER_ID_KEY, updateData);
      return Promise.resolve();
    },
    onSuccess: async () => {
      await tanstackQueryClient.invalidateQueries({
        queryKey: ['user'],
      });
    },
  });
};
